import { useFormContext, useWatch } from 'react-hook-form';
import { StyleSheet } from 'react-native-unistyles';
import Avatar from '@/components/Custom/Avatar';
import Chip from '@/components/UI/Chip';
import { type FragmentOf, graphql, readFragment } from '@/gql/graphql';
import type { EventScorekeepingPanelFormValues } from '../../EventScorekeeping.types';

export const EventScorekeepingPanelPersonFragment = graphql(/* GraphQL */ `
  fragment EventScorekeepingPanelPerson on person {
    id
    name
    avatar_id
    color
    jersey_number(args: { team_id: $teamId })
  }
`);

function EventScorekeepingPanelPerson({
  fragment,
  isChecked,
  isEditing,
  onPress,
  jerseyNumber,
}: {
  fragment: FragmentOf<typeof EventScorekeepingPanelPersonFragment>;
  isChecked: boolean;
  isEditing: boolean;
  onPress: () => void;
  jerseyNumber: string | null;
}) {
  const person = readFragment(EventScorekeepingPanelPersonFragment, fragment);
  const { control } = useFormContext<EventScorekeepingPanelFormValues>();

  const selectedTeam = useWatch({
    control,
    name: 'selectedTeam',
  });

  return (
    <Chip
      style={style.container}
      onValueChange={() => onPress()}
      value={isChecked}
      variant={isEditing ? 'warning' : 'ghost'}
      size="sm"
      label={person.name || ''}
    >
      <Avatar
        size="sm"
        color={selectedTeam?.home_primary_color}
        placeholderText={jerseyNumber}
      />
    </Chip>
  );
}

const style = StyleSheet.create((theme) => ({
  container: {
    padding: 0,
    borderRadius: theme.borderRadius.full,
    maxWidth: theme.size(64),
    paddingRight: theme.size(3),
  },
}));

export default EventScorekeepingPanelPerson;
